import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "timeline-container-mobile mx-3 d-block d-lg-none" }
const _hoisted_2 = { class: "eurostar-hero-mobile mb-3" }
const _hoisted_3 = { class: "eurostar-logo d-flex align-items-center mb-2" }
const _hoisted_4 = { class: "eurostar-logo-box" }
const _hoisted_5 = { class: "timeline-title-mobile heading text-white mb-3" }
const _hoisted_6 = { class: "d-block fw-normal" }
const _hoisted_7 = { class: "eurostar-pill" }
const _hoisted_8 = { class: "d-flex mb-1" }
const _hoisted_9 = { class: "timeline-content-mobile pb-2" }
const _hoisted_10 = { class: "timeline-text-mobile label-blue" }
const _hoisted_11 = { class: "timeline-detail-mobile" }
const _hoisted_12 = { class: "custom-badge-mobile badge-train-mobile" }
const _hoisted_13 = { class: "d-flex mb-1" }
const _hoisted_14 = { class: "timeline-content-mobile pb-2" }
const _hoisted_15 = { class: "timeline-text-mobile label-blue" }
const _hoisted_16 = { class: "timeline-detail-mobile" }
const _hoisted_17 = { class: "custom-badge-mobile badge-stay-orange-mobile" }
const _hoisted_18 = { class: "d-flex mb-1" }
const _hoisted_19 = { class: "timeline-content-mobile pb-2" }
const _hoisted_20 = { class: "timeline-text-mobile label-orange" }
const _hoisted_21 = { class: "d-flex mb-1" }
const _hoisted_22 = { class: "timeline-content-mobile pb-2" }
const _hoisted_23 = { class: "timeline-text-mobile label-grey" }
const _hoisted_24 = { class: "timeline-detail-mobile" }
const _hoisted_25 = { class: "d-flex mb-1" }
const _hoisted_26 = { class: "timeline-content-mobile pb-2" }
const _hoisted_27 = { class: "timeline-text-mobile label-grey" }
const _hoisted_28 = { class: "timeline-detail-mobile" }
const _hoisted_29 = { class: "custom-badge-mobile badge-night-mobile" }
const _hoisted_30 = { class: "d-flex mb-1" }
const _hoisted_31 = { class: "timeline-content-mobile pb-2" }
const _hoisted_32 = { class: "timeline-text-mobile label-blue" }
const _hoisted_33 = { class: "timeline-detail-mobile" }
const _hoisted_34 = { class: "custom-badge-mobile badge-train-mobile" }
const _hoisted_35 = { class: "d-flex" }
const _hoisted_36 = { class: "timeline-content-mobile" }
const _hoisted_37 = { class: "timeline-text-mobile label-blue mb-0" }
const _hoisted_38 = { class: "timeline-detail-mobile" }
const _hoisted_39 = { class: "timeline-section d-none d-lg-flex" }
const _hoisted_40 = { class: "eurostar-hero" }
const _hoisted_41 = { class: "eurostar-logo d-flex align-items-center" }
const _hoisted_42 = { class: "eurostar-logo-box" }
const _hoisted_43 = { class: "eurostar-headline" }
const _hoisted_44 = { class: "d-block" }
const _hoisted_45 = { class: "eurostar-pill" }
const _hoisted_46 = { class: "timeline-track-wrap" }
const _hoisted_47 = { class: "flag flag-blue flag-seg-1" }
const _hoisted_48 = { class: "flag flag-orange flag-point-3" }
const _hoisted_49 = {
  key: 0,
  class: "flag flag-grey flag-point-5"
}
const _hoisted_50 = { class: "flag flag-blue flag-seg-6" }
const _hoisted_51 = { class: "line-cell tlc-6" }
const _hoisted_52 = { class: "label-cell label-blue tlc-1" }
const _hoisted_53 = { class: "label-head" }
const _hoisted_54 = { class: "label-detail" }
const _hoisted_55 = { class: "label-cell label-blue tlc-2" }
const _hoisted_56 = { class: "label-head" }
const _hoisted_57 = { class: "label-detail" }
const _hoisted_58 = { class: "label-cell label-orange tlc-3" }
const _hoisted_59 = { class: "label-head" }
const _hoisted_60 = { class: "label-cell label-grey tlc-4" }
const _hoisted_61 = { class: "label-head" }
const _hoisted_62 = { class: "label-detail" }
const _hoisted_63 = { class: "label-cell label-grey tlc-5" }
const _hoisted_64 = { class: "label-head" }
const _hoisted_65 = { class: "label-detail" }
const _hoisted_66 = { class: "label-cell label-blue tlc-6" }
const _hoisted_67 = { class: "label-head" }
const _hoisted_68 = { class: "label-detail" }
const _hoisted_69 = { class: "label-cell label-blue tlc-7" }
const _hoisted_70 = { class: "label-head" }
const _hoisted_71 = { class: "label-detail" }

import { computed } from "vue"
import { useStore } from "vuex"

import TrainSvgIcon from "./svg/trainSvgIcon.vue"
import SkiSvgIcon from "./svg/skiSvgIcon.vue"
import EurostarSvgIcon from "./svg/eurostarSvgIcon.vue"
import { trainStationCodeMap } from "@/config/trainStationCodeMap"
import {
	getTrainPackageFamily,
	isNlWebsite,
	isUkWebsite,
	variantBelongsToPackCode,
} from "@/config/trainPackageConfig"
import { getDiffrenceDatesInNight } from "@/vue/planning/utils/datePickerHelpers"


export default /*@__PURE__*/_defineComponent({
  __name: 'EurostarTimeLine',
  setup(__props) {

const store = useStore()
const content = computed(() => store.state.content || {})

const t = (key: string, fallback: string) => content.value[key] || fallback

const isUkOrNlSite = isUkWebsite() || isNlWebsite()

const TNE_SIBLING_CODES = ["PFTTUK", "PFPTTUK", "PFTTNL", "PFPTTNL"]
const EUROSTAR_PACKS = ["PFTT", "PFPTT", "HTT"]

const dateFromStateOrHash = (key: "BeginDate" | "EndDate"): string | null => {
	const fromState = store.state.dates?.[key]
	if (fromState) return fromState
	const match = (window.location.hash || "").match(new RegExp(`${key}=([^&]+)`))
	return match ? decodeURIComponent(match[1]) : null
}

const stayNights = computed(() => {
	const begin = dateFromStateOrHash("BeginDate")
	const end = dateFromStateOrHash("EndDate")
	if (!begin || !end) return null
	const nights = Number(getDiffrenceDatesInNight({ start: begin, end }))
	return Number.isFinite(nights) ? nights : null
})

const isTneSiblingPack = (code: string) =>
	TNE_SIBLING_CODES.some((tne) => code === tne || code.startsWith(`${tne}_`))

const belongsToSelectedEurostarPack = (code?: string) => {
	if (!code || isTneSiblingPack(code)) return false
	const selected = store.state.packCode || ""
	const packs = selected ? getTrainPackageFamily(selected) : EUROSTAR_PACKS
	return packs.some((pack) => variantBelongsToPackCode(code, pack))
}

// UK Eurostar skipass 7 is 7 nights in resort + 1 night near the station (HTT_PLUS1 / PFTT_8),
// even when the ski residence itself is Sat→Sat. NL skipass 7 can be a Christmas 7-day pass
// without that extra hotel night — there 7+1 is `_8` or an 8-night stay.
const isPlusOneNightOffer = (offer: { codePackage?: string; skipass?: number | string }) => {
	const code = offer.codePackage || ""
	if (!belongsToSelectedEurostarPack(code)) return false
	if (code.includes("_8")) return true
	if (isUkWebsite() && Number(offer.skipass) === 7) return true
	return false
}

const hasPlusOneNight = computed(() => {
	if (!isUkOrNlSite) return true
	if ((stayNights.value ?? 0) >= 8) return true
	const variants = store.getters.variants || []
	const wiyp = store.state.availablePackageCodeWiyp || []
	return [...variants, ...wiyp].some(isPlusOneNightOffer)
})

const holidayDaysLabel = computed(() => {
	const sevenDays = t("planning_eurostar_7days", "7 days")
	if (hasPlusOneNight.value) return sevenDays
	return content.value["planning_eurostar_6days"] || sevenDays.replace(/7/g, "6")
})

const returnDayLabel = computed(() =>
	hasPlusOneNight.value
		? t("planning_eurostar_sunday", "Sunday")
		: t("planning_eurostar_saturday", "Saturday")
)

const headlineRegular = computed(() => {
	const full = t("planning_eurostar_headline_regular", "on Saturdays and return Sundays.")
	if (hasPlusOneNight.value) return full
	const fromCms = content.value["planning_eurostar_headline_regular_short"]
	if (fromCms) return fromCms
	const sunday = t("planning_eurostar_sunday", "Sunday")
	const saturday = t("planning_eurostar_saturday", "Saturday")
	return full
		.replace(/Sundays/gi, "Saturdays")
		.replace(new RegExp(`${sunday}s`, "gi"), `${saturday}s`)
		.replace(new RegExp(sunday, "gi"), saturday)
})

const originCode = computed(() => store.state.flightOrigin?.split("-")[0] || "")

const originLabel = computed(() => {
	const code = originCode.value
	if (!code) return t("planning_eurostar_outbound_from", "London St Pancras")

	const fromContent = content.value["planning_traintimeline_station"]?.[code]
	return (
		fromContent?.name ||
		fromContent?.short ||
		trainStationCodeMap.get(code)?.name ||
		t("planning_eurostar_outbound_from", "London St Pancras")
	)
})

const alpineStationLabel = computed(() =>
	t("planning_eurostar_station", "Station")
)

const arrivalOriginLabel = computed(() => {
	const arrivalTemplate = t("planning_eurostar_arrival_london", "Arrival {origin}")
	if (arrivalTemplate.includes("{origin}")) {
		return arrivalTemplate.replace("{origin}", originLabel.value)
	}
	// Legacy CMS copy like "Arrival London St Pancras" → keep prefix, use selected origin
	if (arrivalTemplate.toLowerCase().startsWith("arrival")) {
		return `${t("planning_eurostar_arrival", "Arrival")} ${originLabel.value}`
	}
	return `${t("planning_eurostar_arrival", "Arrival")} ${originLabel.value}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(EurostarSvgIcon, {
              width: 18,
              height: 18,
              color: "#ffffff"
            })
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "eurostar-logo-text" }, "eurostar", -1))
        ]),
        _createElementVNode("h2", _hoisted_5, [
          _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_headline_bold', 'Get from London to the French Alps')), 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(headlineRegular.value), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[3] || (_cache[3] = _createElementVNode("svg", {
            width: "16",
            height: "16",
            class: "icon"
          }, [
            _createElementVNode("use", { "xlink:href": "#___icon___home" })
          ], -1)),
          _createTextVNode(" " + _toDisplayString(t('planning_eurostar_nights_resort', '7 nights in resort')) + " ", 1),
          (hasPlusOneNight.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[1] || (_cache[1] = _createElementVNode("span", null, "+", -1)),
                _cache[2] || (_cache[2] = _createElementVNode("svg", {
                  width: "16",
                  height: "16",
                  class: "icon"
                }, [
                  _createElementVNode("use", { "xlink:href": "#___icon___night" })
                ], -1)),
                _createTextVNode(" " + _toDisplayString(t('planning_eurostar_night_station', '1 night near station')), 1)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "timeline-visual-mobile d-flex flex-column align-items-center me-3" }, [
          _createElementVNode("div", { class: "timeline-point-mobile point-ring-blue" }),
          _createElementVNode("div", { class: "timeline-line-mobile line-blue-mobile flex-grow-1" })
        ], -1)),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createTextVNode(_toDisplayString(t('planning_eurostar_morning', 'Morning')) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_departure', 'Departure')), 1),
            _createElementVNode("span", _hoisted_11, _toDisplayString(originLabel.value) + " → " + _toDisplayString(alpineStationLabel.value), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(TrainSvgIcon, {
              color: "var(--primary-blue)",
              width: 16,
              height: 16,
              fill: "var(--primary-blue)",
              stroke: "var(--primary-blue)"
            }),
            _createTextVNode(" " + _toDisplayString(t('planning_eurostar_saturday', 'Saturday')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "timeline-visual-mobile d-flex flex-column align-items-center me-3" }, [
          _createElementVNode("div", { class: "timeline-point-mobile point-ring-orange" }),
          _createElementVNode("div", { class: "timeline-line-mobile line-orange-mobile flex-grow-1" })
        ], -1)),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createTextVNode(_toDisplayString(t('planning_eurostar_evening', 'Evening')) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_arrival', 'Arrival')), 1),
            _createElementVNode("span", _hoisted_16, _toDisplayString(t('planning_eurostar_transfer_resort', 'Transfert to resort')), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(SkiSvgIcon, {
              color: "#f56600",
              width: 16,
              height: 16,
              fill: "#f56600",
              stroke: "#f56600"
            }),
            _createTextVNode(" " + _toDisplayString(holidayDaysLabel.value), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "timeline-visual-mobile d-flex flex-column align-items-center me-3" }, [
          _createElementVNode("div", { class: "timeline-point-mobile point-fill-orange" }),
          _createElementVNode("div", { class: "timeline-line-mobile line-orange-mobile flex-grow-1" })
        ], -1)),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createTextVNode(_toDisplayString(holidayDaysLabel.value) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_enjoy', 'Enjoy your holiday')), 1)
          ])
        ])
      ]),
      (hasPlusOneNight.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_21, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "timeline-visual-mobile d-flex flex-column align-items-center me-3" }, [
                _createElementVNode("div", { class: "timeline-point-mobile point-ring-grey" }),
                _createElementVNode("div", { class: "timeline-line-mobile line-lightgrey-mobile flex-grow-1" })
              ], -1)),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createTextVNode(_toDisplayString(t('planning_eurostar_afterski', 'After skiing')) + " ", 1),
                  _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_after_skiing_short', 'Transfer')), 1),
                  _createElementVNode("span", _hoisted_24, _toDisplayString(t('planning_eurostar_transfer_hotel', 'Transfer to hotel in the vicinity of the train station')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "timeline-visual-mobile d-flex flex-column align-items-center me-3" }, [
                _createElementVNode("div", { class: "timeline-point-mobile point-fill-grey" }),
                _createElementVNode("div", { class: "timeline-line-mobile line-lightgrey-mobile flex-grow-1" })
              ], -1)),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createTextVNode(_toDisplayString(t('planning_eurostar_night', 'Night')) + " ", 1),
                  _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_night_stay', '1 night stay')), 1),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(t('planning_eurostar_night_rest', "A night's rest in a hotel closer to the station")), 1)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _cache[8] || (_cache[8] = _createElementVNode("svg", {
                    width: "16",
                    height: "16",
                    class: "icon"
                  }, [
                    _createElementVNode("use", { "xlink:href": "#___icon___night" })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(t('planning_eurostar_saturday', 'Saturday')), 1)
                ])
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_30, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "timeline-visual-mobile d-flex flex-column align-items-center me-3" }, [
          _createElementVNode("div", { class: "timeline-point-mobile point-ring-blue" }),
          _createElementVNode("div", { class: "timeline-line-mobile line-blue-mobile flex-grow-1" })
        ], -1)),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createTextVNode(_toDisplayString(t('planning_eurostar_morning', 'Morning')) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_departure', 'Departure')), 1),
            _createElementVNode("span", _hoisted_33, _toDisplayString(alpineStationLabel.value) + " → " + _toDisplayString(originLabel.value), 1)
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createVNode(TrainSvgIcon, {
              color: "var(--primary-blue)",
              width: 16,
              height: 16,
              fill: "var(--primary-blue)",
              stroke: "var(--primary-blue)"
            }),
            _createTextVNode(" " + _toDisplayString(returnDayLabel.value), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "timeline-visual-mobile d-flex flex-column align-items-center me-3" }, [
          _createElementVNode("div", { class: "timeline-point-mobile point-ring-blue" })
        ], -1)),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createTextVNode(_toDisplayString(t('planning_eurostar_evening', 'Evening')) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_arrival', 'Arrival')), 1),
            _createElementVNode("span", _hoisted_38, _toDisplayString(arrivalOriginLabel.value), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("span", _hoisted_42, [
            _createVNode(EurostarSvgIcon, {
              width: 18,
              height: 18,
              color: "#ffffff"
            })
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("span", { class: "eurostar-logo-text" }, "eurostar", -1))
        ]),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_headline_bold', 'Get from London to the French Alps')), 1),
          _createElementVNode("span", _hoisted_44, _toDisplayString(headlineRegular.value), 1)
        ]),
        _createElementVNode("div", _hoisted_45, [
          _cache[15] || (_cache[15] = _createElementVNode("svg", {
            width: "16",
            height: "16",
            class: "icon"
          }, [
            _createElementVNode("use", { "xlink:href": "#___icon___home" })
          ], -1)),
          _createTextVNode(" " + _toDisplayString(t('planning_eurostar_nights_resort', '7 nights in resort')) + " ", 1),
          (hasPlusOneNight.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[13] || (_cache[13] = _createElementVNode("span", null, "+", -1)),
                _cache[14] || (_cache[14] = _createElementVNode("svg", {
                  width: "16",
                  height: "16",
                  class: "icon"
                }, [
                  _createElementVNode("use", { "xlink:href": "#___icon___night" })
                ], -1)),
                _createTextVNode(" " + _toDisplayString(t('planning_eurostar_night_station', '1 night near station')), 1)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", {
          class: _normalizeClass(["timeline-track", { 'is-compact': !hasPlusOneNight.value }])
        }, [
          _createElementVNode("div", _hoisted_47, [
            _createVNode(TrainSvgIcon, {
              color: "var(--primary-blue)",
              width: 16,
              height: 16,
              fill: "var(--primary-blue)",
              stroke: "var(--primary-blue)"
            }),
            _createTextVNode(" " + _toDisplayString(t('planning_eurostar_saturday', 'Saturday')), 1)
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createVNode(SkiSvgIcon, {
              color: "#f56600",
              width: 16,
              height: 16,
              fill: "#f56600",
              stroke: "#f56600"
            }),
            _createTextVNode(" " + _toDisplayString(holidayDaysLabel.value), 1)
          ]),
          (hasPlusOneNight.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _cache[16] || (_cache[16] = _createElementVNode("svg", {
                  width: "15",
                  height: "15",
                  class: "icon"
                }, [
                  _createElementVNode("use", { "xlink:href": "#___icon___night" })
                ], -1)),
                _createTextVNode(" " + _toDisplayString(t('planning_eurostar_saturday', 'Saturday')), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_50, [
            _createVNode(TrainSvgIcon, {
              color: "var(--primary-blue)",
              width: 16,
              height: 16,
              fill: "var(--primary-blue)",
              stroke: "var(--primary-blue)"
            }),
            _createTextVNode(" " + _toDisplayString(returnDayLabel.value), 1)
          ]),
          _cache[20] || (_cache[20] = _createStaticVNode("<div class=\"line-cell tlc-1\" data-v-7023f6c4><span class=\"half half-none\" data-v-7023f6c4></span><span class=\"dot dot-ring-blue\" data-v-7023f6c4></span><span class=\"half half-blue\" data-v-7023f6c4></span></div><div class=\"line-cell tlc-2\" data-v-7023f6c4><span class=\"half half-blue\" data-v-7023f6c4></span><span class=\"dot dot-ring-orange\" data-v-7023f6c4></span><span class=\"half half-orange\" data-v-7023f6c4></span></div><div class=\"line-cell tlc-3\" data-v-7023f6c4><span class=\"half half-orange\" data-v-7023f6c4></span><span class=\"dot dot-fill-orange\" data-v-7023f6c4></span><span class=\"half half-orange\" data-v-7023f6c4></span></div>", 3)),
          (hasPlusOneNight.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[17] || (_cache[17] = _createStaticVNode("<div class=\"line-cell tlc-4\" data-v-7023f6c4><span class=\"half half-orange\" data-v-7023f6c4></span><span class=\"dot dot-ring-grey\" data-v-7023f6c4></span><span class=\"half half-lightgrey\" data-v-7023f6c4></span></div><div class=\"line-cell tlc-5\" data-v-7023f6c4><span class=\"half half-lightgrey\" data-v-7023f6c4></span><span class=\"dot dot-fill-grey\" data-v-7023f6c4></span><span class=\"half half-lightgrey\" data-v-7023f6c4></span></div>", 2))
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("span", {
              class: _normalizeClass(["half", hasPlusOneNight.value ? 'half-lightgrey' : 'half-orange'])
            }, null, 2),
            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "dot dot-ring-blue" }, null, -1)),
            _cache[19] || (_cache[19] = _createElementVNode("span", { class: "half half-blue" }, null, -1))
          ]),
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "line-cell tlc-7" }, [
            _createElementVNode("span", { class: "half half-blue" }),
            _createElementVNode("span", { class: "dot dot-ring-blue" }),
            _createElementVNode("span", { class: "half half-none" })
          ], -1)),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("span", _hoisted_53, [
              _createTextVNode(_toDisplayString(t('planning_eurostar_morning', 'Morning')), 1),
              _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_departure', 'Departure')), 1)
            ]),
            _createElementVNode("span", _hoisted_54, _toDisplayString(originLabel.value) + " → " + _toDisplayString(alpineStationLabel.value), 1)
          ]),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("span", _hoisted_56, [
              _createTextVNode(_toDisplayString(t('planning_eurostar_evening', 'Evening')), 1),
              _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_arrival', 'Arrival')), 1)
            ]),
            _createElementVNode("span", _hoisted_57, _toDisplayString(t('planning_eurostar_transfer_resort', 'Transfert to resort')), 1)
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("span", _hoisted_59, [
              _createTextVNode(_toDisplayString(holidayDaysLabel.value), 1),
              _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_enjoy', 'Enjoy your holiday')), 1)
            ])
          ]),
          (hasPlusOneNight.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("span", _hoisted_61, [
                    _createTextVNode(_toDisplayString(t('planning_eurostar_afterski', 'After skiing')), 1),
                    _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_after_skiing_short', 'Transfer')), 1)
                  ]),
                  _createElementVNode("span", _hoisted_62, _toDisplayString(t('planning_eurostar_transfer_hotel', 'Transfer to hotel in the vicinity of the train station')), 1)
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("span", _hoisted_64, [
                    _createTextVNode(_toDisplayString(t('planning_eurostar_night', 'Night')), 1),
                    _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_night_stay', '1 night stay')), 1)
                  ]),
                  _createElementVNode("span", _hoisted_65, _toDisplayString(t('planning_eurostar_night_rest', "A night's rest in a hotel closer to the station")), 1)
                ])
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("span", _hoisted_67, [
              _createTextVNode(_toDisplayString(t('planning_eurostar_morning', 'Morning')), 1),
              _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_departure', 'Departure')), 1)
            ]),
            _createElementVNode("span", _hoisted_68, _toDisplayString(alpineStationLabel.value) + " → " + _toDisplayString(originLabel.value), 1)
          ]),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("span", _hoisted_70, [
              _createTextVNode(_toDisplayString(t('planning_eurostar_evening', 'Evening')), 1),
              _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_arrival', 'Arrival')), 1)
            ]),
            _createElementVNode("span", _hoisted_71, _toDisplayString(arrivalOriginLabel.value), 1)
          ])
        ], 2)
      ])
    ])
  ], 64))
}
}

})